"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Reprezentacja listy produktów
 */
var ProductList = /** @class */ (function () {
    function ProductList() {
        this.template = 'category';
        this.name = '';
        this.size = 0;
        this.productList = [];
    }
    return ProductList;
}());
exports.default = ProductList;
